"use client";

import { useEffect, useState } from "react";
import { useAgendaSocket } from "@/hooks/use-agenda-socket";
import { getAgendaEnabled, PERMISSIONS_UPDATED_EVENT } from "@/lib/permissions";

/**
 * Isola `useAgendaSocket()` num componente que só monta quando a Agenda está
 * ligada — mesmo mecanismo de `VoiceShell`/`WebphoneSticky` (`getVoiceEnabled()`,
 * `voice-shell.tsx`): lá o socket SIP só conecta quando `WebphoneSticky` monta;
 * aqui o socket.io do namespace `/agenda` só conecta quando este componente
 * monta. Hooks não podem ser chamados condicionalmente (`if (x) useFoo()`),
 * então o gate precisa acontecer no NÍVEL DO COMPONENTE, não dentro da função —
 * daí o wrapper.
 *
 * Sem isto, `dashboard/layout.tsx` chamava `useAgendaSocket()` incondicional em
 * toda página do dashboard: com AGENDA_ENABLED desligado o `AgendaGateway`
 * nunca é instanciado no backend (módulo fora do grafo), e o socket.io-client
 * ficava em reconexão perpétua a cada ~3-5s (`reconnectionDelay: 3000` em
 * `use-agenda-socket.ts`), em TODA sessão autenticada — mesma classe de storm
 * já vista em #83-85.
 */
function AgendaSocketMount() {
  useAgendaSocket();
  return null;
}

export function AgendaSocketGate() {
  // Mesma dança de VoiceShell: começa `false` pra não divergir da hidratação
  // (`getAgendaEnabled` lê localStorage, que não existe no servidor), decide
  // depois da montagem e reage a `PERMISSIONS_UPDATED_EVENT` — a flag chega
  // junto do resto de `/auth/permissions` via `useLivePermissions`.
  const [agendaEnabled, setAgendaEnabled] = useState(false);

  useEffect(() => {
    const sync = () => setAgendaEnabled(getAgendaEnabled());
    sync();
    window.addEventListener(PERMISSIONS_UPDATED_EVENT, sync);
    return () => window.removeEventListener(PERMISSIONS_UPDATED_EVENT, sync);
  }, []);

  return agendaEnabled ? <AgendaSocketMount /> : null;
}
